module.exports = __webpack_public_path__ + "img/AU.649d788a.svg";